/* eslint-disable no-param-reassign */
/* eslint-disable camelcase */
import axios from 'axios';

const socialConfig = window.socialConfig || {};

const accessTokenProperties = socialConfig.access_token_properties || {};

let {
  access_token, refresh_token, expires_in, created_at,
} = accessTokenProperties;
let expires_at = created_at + expires_in;

const fetchSocialToken = async ({ isRefresh }) => {
  const url = isRefresh ? `/social/refresh_token?refresh_token=${refresh_token}` : '/social/access_token';
  const response = await (await fetch(url)).json();
  ({
    access_token, refresh_token, expires_in, created_at,
  } = response);
  expires_at = created_at + expires_in;
};

const handleUseSocialToken = async (config) => {
  const shouldUseToken = config.url.includes('intellumsocial.com') || config.url.includes('tribe');

  if (shouldUseToken) {
    const shouldFetchInitialToken = !expires_at;

    if (shouldFetchInitialToken) await fetchSocialToken({ isRefresh: false });

    const currentTime = Math.round(new Date().valueOf() / 1000);

    const shouldRefreshToken = refresh_token && currentTime > expires_at;

    if (shouldRefreshToken) await fetchSocialToken({ isRefresh: true });

    if (access_token) {
      config.headers.common.Authorization = `Bearer ${access_token}`;
    }
  }

  const isGCSCall = config.url.includes('storage.googleapis.com');
  const isS3Call = config.url.includes('s3.amazonaws.com');

  if (isS3Call || isGCSCall) {
    delete config.headers.common.Authorization;
    delete config.headers.common['X-CSRF-TOKEN'];
  }

  return config;
};

export default () => {
  const token = document.querySelector('[name=csrf-token]').content;

  axios.defaults.headers.common['X-CSRF-TOKEN'] = token;

  axios.interceptors.request.use(handleUseSocialToken, (error) => Promise.reject(error));
};
